import _classCallCheck from "/opt/build/repo/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';

// eslint-disable-line import/no-extraneous-dependencies
var MouseTooltip = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MouseTooltip, _React$PureComponent);

  var _super = _createSuper(MouseTooltip);

  function MouseTooltip() {
    var _this;

    _classCallCheck(this, MouseTooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      xPosition: 0,
      yPosition: 0,
      mouseMoved: false,
      listenerActive: false
    });

    _defineProperty(_assertThisInitialized(_this), "getTooltipPosition", function (_ref) {
      var xPosition = _ref.clientX,
          yPosition = _ref.clientY;

      _this.setState({
        xPosition: xPosition,
        yPosition: yPosition,
        mouseMoved: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addListener", function () {
      window.addEventListener('mousemove', _this.getTooltipPosition);

      _this.setState({
        listenerActive: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeListener", function () {
      window.removeEventListener('mousemove', _this.getTooltipPosition);

      _this.setState({
        listenerActive: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateListener", function () {
      if (!_this.state.listenerActive && _this.props.visible) {
        _this.addListener();
      }

      if (_this.state.listenerActive && !_this.props.visible) {
        _this.removeListener();
      }
    });

    return _this;
  }

  _createClass(MouseTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addListener();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateListener();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListener();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: this.props.className,
        style: _objectSpread({
          display: this.props.visible && this.state.mouseMoved ? 'block' : 'none',
          position: 'fixed',
          top: this.state.yPosition + this.props.offsetY,
          left: this.state.xPosition + this.props.offsetX
        }, this.props.style)
      }, this.props.children);
    }
  }]);

  return MouseTooltip;
}(React.PureComponent);

_defineProperty(MouseTooltip, "defaultProps", {
  visible: true,
  offsetX: 0,
  offsetY: 0
});

export default MouseTooltip;